export const GET_COMPANIES = "GET_COMPANIES";
export const RESET_COMPANIES = "RESET_COMPANIES";
export const SET_COMPANY_SCORING = "SET_COMPANY_SCORING";